import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(null, async (error) => {
  const cfg = error.config || {};
  const method = (cfg.method || "get").toLowerCase();
  const status = error.response?.status;
  const retriable =
    method === "get" &&
    (!error.response || status === 502 || status === 503 || status === 504);
  if (retriable && !cfg._retried) {
    cfg._retried = true;
    await new Promise((r) => setTimeout(r, 1500));
    return api(cfg);
  }
  return Promise.reject(error);
});

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const SITE_NAME = "VANROCK Track Solutions";
export const GLOBAL_URL = "https://vanrockglobal.com";
export const SITE_URL = BACKEND_URL;
export const LOGO = "/vanrock-logo.png";
export const LOGO_DARK = "/vanrock-logo-dark.png";
export const PLACEHOLDER = {
  company: "VANROCK Track Solutions — part of VANROCK Group",
  phone: "+1 (555) 123-4567",
  email: "sales@vanrockglobal.example",
  address: "1234 Industrial Ave, Houston, TX (placeholder)",
  hours: "Mon–Fri: 8:00 – 17:00",
};
